<div class="wrapper">
  <div class="wrapper-action" (click)="updateStatus()">
    @if (status === 'paused') {
      <i class="fal fa-play"></i>
    } @else {
      <i class="fal fa-pause"></i>
    }
  </div>
  <div class="hour">
    {{ startTime() }}
  </div>
  <div class="wrapper-progress">
    <div
      class="current-progress-bar"
      [style.width.%]="progress()"
      (click)="onClickProgressBar($event)"
      [style.transition-duration.ms]="intervalValue"
    ></div>
    <div
      class="global-progress-bar"
      #globalProgressBar
      (click)="onClickProgressBar($event)"
    ></div>
    <div
      class="cursor"
      [title]="currentPosition() + 1 + '/' + path.polyline.length"
      [style.left.%]="progress()"
      [style.transition-duration.ms]="intervalValue"
    >
      @if (currentPosition() !== 0) {
        <div class="text">
          {{ infoWindowText() }}
        </div>
        <div class="triangle-wrapper">
          <div class="triangle border"></div>
          <div class="triangle inner"></div>
        </div>
      }
    </div>
  </div>
  <div class="hour">
    {{ endTime() }}
  </div>
</div>
